import { Component, OnInit } from '@angular/core';
import { ClubServicesService } from 'src/app/shared/services/club-services.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { MatDialog } from '@angular/material/dialog';
import { AddcardDetailsComponent } from "src/app/shared/modal/addcard-details/addcard-details.component";
import { OrderSuccessDialogueComponent } from 'src/app/shared/modal/order-success/order-success-dialogue.component';
import { ActivatedRoute } from '@angular/router';
import { PlayerServicesService } from 'src/app/shared/services/players-services.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-players-payment',
  templateUrl: './players-payment.component.html',
  styleUrls: ['./players-payment.component.scss']
})
export class PlayersPaymentComponent implements OnInit {

  cartItems: any = [];
  cardsList: any = [];
  cartId: any;
  totalCost: any = 0;
  totalItems: any = 0;
  requestData: any = {};
  cardId: any;
  paynowId: any;
  cvv: any;
  currentUser: any;
  orderId: any;
  requestId: any;
  isPaymentFailed:any;
  constructor(
    private commonService: CommonService,
    private clubService: ClubServicesService,
    private dialogue: MatDialog,
    private router: ActivatedRoute,
    private playerService: PlayerServicesService,
    private toastService: ToastrService
  ) { }

  ngOnInit(): void {
    this.currentUser = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.currentUser);

    this.getCards();


    this.commonService.getAllCardsList$.subscribe((result: any) => {
      this.getCards();
    })

    if (this.currentUser?.userDetails?.userType == 3 || this.currentUser?.userType == 3) {
      this.getCartItemsPlayer();
    } else {
      this.getCartItems();
    }

    this.router.queryParams.subscribe((params: any) => {
      this.paynowId = params['id'];
      this.requestId = params['requestId'];
      this.orderId = params['orderId'];
      this.isPaymentFailed = params['paymentFailed'];
      
    })

    if (this.paynowId) {

    }
  }



  getCartItems() {
    this.commonService.viewCartDetails().subscribe((res: any) => {
      console.log(res);
      if (res.status == 200) {
        this.cartItems = res.output;
        this.cartId = res.output[0]?._id
        this.totalItems = 0;
        this.totalCost = 0;
        // let totalItems: any = [];
        // for (var i of this.cartItems.items) {
        //   this.totalItems = this.totalItems + parseInt(i?.quantity);
        //   this.totalCost = this.totalCost + parseInt(i?.quantity) * parseInt(i?.productData?.productPrice);
        //   totalItems.push({
        //     "productId": i?.productId,
        //     "quantity": i?.quantity,
        //     "isFree": false,
        //     "isFreeQuantity": 0
        //   })
        // }

        // this.requestData = {
        //   "eventId": this.cartItems?.eventId,
        //   "eventDate": this.cartItems?.eventDate,
        //   "restaurantId": this.cartItems?.restaurantId,
        //   "deliveryTime": this.cartItems?.deliveryTime,
        //   "items": totalItems,
        //   "payLater": false,
        //   "deliveryCharges": this.cartItems?.userData?.deliveryCharges ? this.cartItems?.userData?.deliveryCharges : 0
        // }
      }
    })
  }


  getCartItemsPlayer() {
    this.playerService.getPlayerCart().subscribe((res: any) => {
      if (res.status == 200) {
        let totalItems: any = [];
        this.cartItems = res.output;
        this.cartId = res.output[0]?._id
        this.totalItems = 0;
        this.totalCost = 0;
        // for (var i of this.cartItems.items) {
        //   this.totalItems = this.totalItems + parseInt(i?.quantity);
        //   this.totalCost = this.totalCost + parseInt(i?.quantity) * parseInt(i?.productData?.productPrice);
        //   totalItems.push({
        //     "productId": i?.productId,
        //     "quantity": i?.quantity,
        //     "isFree": false,
        //     "isFreeQuantity": 0
        //   })
        // }

        // this.requestData = {
        //   "eventId": this.cartItems?.eventId,
        //   "eventDate": this.cartItems?.eventDate,
        //   "restaurantId": this.cartItems?.restaurantId,
        //   "deliveryTime": this.cartItems?.deliveryTime,
        //   "items": totalItems,
        //   "payLater": false,
        //   "deliveryCharges": this.cartItems?.userData?.deliveryCharges ? this.cartItems?.userData?.deliveryCharges : 0
        // }
      }
    })
  }

  cardSelect(e: any, data: any) {
    if (e.target.checked == true) {
      for (var i of this.cardsList) {
        (<HTMLInputElement>document.getElementById('cvvText' + i.id)).style.display = "none";
        (<HTMLInputElement>document.getElementById('checkbox' + i.id)).checked = false;

      }
      this.cardId = data.id;
      console.log(this.cardId);
      this.requestData['cardId'] = this.cardId;
      this.cvv = (<HTMLInputElement>document.getElementById('cvvText' + this.cardId)).value;
      (<HTMLInputElement>document.getElementById('cvvText' + this.cardId)).style.display = "block";
      (<HTMLInputElement>document.getElementById('checkbox' + this.cardId)).checked = true;
      this.isPaymentFailed = false;
    } else {
      delete this.requestData.cardId;
      (<HTMLInputElement>document.getElementById('cvvText' + this.cardId)).style.display = "none";
      this.cardId = undefined;
      this.cvv = undefined;
    }


  }

  pressCvv(id: any) {
    let cvv = (<HTMLInputElement>document.getElementById('cvvText' + id)).value;
    if (id == this.cardId) {
      this.cvv = cvv;
    } else {
      this.cvv = undefined
    }
  }

  getCards() {
    this.clubService.getCards().subscribe((res: any) => {
      if (res.status == 200) {
        this.cardsList = res.output
      }
    })
  }


  addCard() {
    try {
      console.log
      this.dialogue.open(AddcardDetailsComponent, {
        id: 'add-card-details-players',
        width: "469px",
        hasBackdrop: true,
        disableClose: true,
        data: {
          userType: {
            titleOne: '',
            titleTwo: '',
            text: "",
            user: "",
            imgPath: '',
            id: '',
            access: 'addCard',
            teamName: ''
          }
        },
      });
    }
    catch (e) { }
  }

  payNowRequest() {
    let data = {
      "payReqId": this.requestId,
      "cardId": this.cardId,
      "orderId": this.orderId
    }
    this.playerService.paymentRequest(data).subscribe((res: any) => {
      if (res.status == 200) {
        this.orderSuccess();
      }
    })
  }

  placeOrder() {
    // delete this.requestData.cardId
    if (this.paynowId) {
      if (this.currentUser?.userDetails?.userType == 3 || this.currentUser?.userType == 3) {
        let req = { "cardId": this.cardId, "orderId": this.paynowId }
        // if(this.isPaymentFailed==true){
        //   req['reAttempt']=1
        // }
        this.playerService.playerPayNow(req).subscribe((res: any) => {
          if (res.status == 200) {
            this.orderSuccess();
          }
        },(err=>{
          this.isPaymentFailed= true;
          this.toastService.error(err?.error?.error?.message)
        }))
      } else {
        let req = { "cardId": this.cardId, "orderId": this.paynowId };
        // if(this.isPaymentFailed==true){
        //   req['reAttempt']=1
        // }
        this.clubService.payNow(req).subscribe((res: any) => {
          if (res.status == 200) {
            this.orderSuccess();
          }
        },(err)=>{
          this.isPaymentFailed= true;
          this.toastService.error(err?.error?.error?.message)
        })
      }
    } else {



      let requestData: any;
      let orderData: any = [];

      let totalAmt = 0;
      let tax = 0;
      for (var i of this.cartItems) {
        let totalItems: any = [];
        totalAmt = 0;
        tax = 0;
        for (var j of i.items) {
          totalAmt = totalAmt + (j.productData?.productPrice * j.quantity);
          totalItems.push({
            "productId": j?.productId,
            "quantity": j?.quantity,
            "isFree": false,
            "isFreeQuantity": 0
          })
        }

        // Calculate tax based on user type
        if (this.currentUser?.userDetails?.userType === 3 || this.currentUser.userType == 3) {
          // 23% tax for players
          tax = (totalAmt * 23) / 100;
        } else if (this.currentUser?.userDetails?.userType === 2 || this.currentUser.userType == 2) {
          // 15% tax for coaches
          tax = (totalAmt * 15) / 100;
        } else {
          // 0% tax for others
          tax = 0;
        }
        requestData = {
          "eventId": i?.eventId,
          "eventDate": i?.eventDate,
          "restaurantId": i?.restaurantId,
          "deliveryTime": i?.deliveryTime,
          "items": totalItems,
          "deliveryCharges": i?.userData?.deliveryCharges ? i?.userData?.deliveryCharges : 0,
          "notes": i?.notes
        }

        requestData['taxAmount'] = 0;
        requestData['coachFreeMeal']= false
        if (this.cartItems[0].coachFreeMeal) {
          requestData['coachFreeMeal'] = true;
        }

        requestData['taxAmount'] = parseFloat(this.convertToDecimal(tax));
        tax = 0;
        orderData.push(requestData);
      }
      // if (this.currentUser?.userDetails?.userType === 3 || this.currentUser.userType == 3) {
      //   requestData['taxAmount'] = parseFloat(this.convertToDecimal(tax));
      //   tax = 0;
      // } else {
      //   requestData['taxAmount'] = 0
      // }

      let data = {};
      data['payLater'] = false;
      data['orderData'] = orderData;
      data['cardId'] = this.cardId;

      this.requestData = data;

      if (this.currentUser?.userDetails?.userType == 3 || this.currentUser?.userType == 3) {
        // if(this.isPaymentFailed==true){
        //   this.requestData['reAttempt']=1
        // }
        this.playerService.playerAddOrder(this.requestData).subscribe((res: any) => {
          if (res.status == 200) {
            this.orderSuccess();
          }
        },(err)=>{
          this.isPaymentFailed= true;
          this.toastService.error(err?.error?.error?.message)
        })
      } else {
        let clubOrderDetails = JSON.parse(localStorage.getItem('clubOrderDetails'));
        if (clubOrderDetails) {
          let newPayload = {};
          newPayload['payLater'] = false;
          newPayload['cardId'] = this.requestData.cardId;
          newPayload['orderData'] = clubOrderDetails;
          this.requestData = newPayload;
        }


        if (this.currentUser?.userDetails?.userType === 2 || this.currentUser.userType == 2) {
          if (this.cartItems[0].coachFreeMeal) {
            for(var i of this.requestData.orderData){
              i['taxAmount'] = 0;
              i['coachFreeMeal'] = true;
            }
          }else{
            // Calculate 15% tax for coaches
            for(var i of this.requestData.orderData){
              let totalAmt = 0;
              // Calculate total amount for this order
              for (var item of i.items) {
                // Find the corresponding cart item to get price
                for (var cartItem of this.cartItems) {
                  if (cartItem.eventId === i.eventId) {
                    for (var cartProduct of cartItem.items) {
                      if (cartProduct.productId === item.productId) {
                        totalAmt += (cartProduct.productData?.productPrice * item.quantity);
                      }
                    }
                  }
                }
              }
              // Apply 15% tax
              let tax = (totalAmt * 15) / 100;
              i['taxAmount'] = parseFloat(tax.toFixed(2));
              i['coachFreeMeal']= false;
            }
          }
        }else{
          i['coachFreeMeal']= false;
        }

        // if(this.isPaymentFailed==true){
        //   this.requestData['reAttempt']=1
        // }

        this.clubService.placeOrder(this.requestData).subscribe((res: any) => {
          if (res.status == 200) {
            localStorage.removeItem('clubOrderDetails');
            this.orderSuccess();
          }
        },(err)=>{
          this.isPaymentFailed= true;
          this.toastService.error(err?.error?.error?.message)
        })
      }

      // playerAddOrder
    }
  }

  convertToDecimal(data: any) {
    return data?.toFixed(2);
  }

  orderSuccess() {
    try {
      const dialogRef = this.dialogue.open(OrderSuccessDialogueComponent, {
        hasBackdrop: true,
        disableClose: true,
        width: '469px',
        data: {
          userType: {
            titleOne: 'Order Placed Successfully!',
            text: "",
            imgPath: '../../../../assets/icon/thumb.png',
            access: "orderSuccess",
            id: '',
          }
        },
      });
    }
    catch (e) { }
  }


  numberOnly(evt: any) {
    console.log(evt);
    let value = evt.target.value;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode == 46) {
      return false;
    }
    if (charCode == 8 || charCode == 37) {
      return true;
    } else if (charCode == 46 && value.indexOf(".") != -1) {
      return false;
    } else if (
      charCode > 31 &&
      charCode != 46 &&
      (charCode < 48 || charCode > 57)
    ) {
      return false;
    }
    return true;
  }


  checkCvcChar(id: any) {
    let data = (<HTMLInputElement>document.getElementById('cvvText' + id)).value;
    data = data?.trim();
    data = data?.replace(" ", '')
    if (data) {
      let res = this.isOnlyDigits(data);
      if (!res) {
        this.cvv = undefined;
        (<HTMLInputElement>document.getElementById('cvvText' + id)).value = '';
      }
    }
  }

  isOnlyDigits(string: any) {
    string = string.replaceAll(" ", '');
    for (let i = 0; i < string.length; i++) {
      var ascii = string.charCodeAt(i);
      if (ascii < 48 || ascii > 57) {
        return false;
      }
    }
    return true
  }

  calculateTax(data: any) {
    this.currentUser = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.currentUser);

    let amt: any = parseFloat(data);

    if (this.currentUser?.userDetails?.userType === 3 || this.currentUser.userType == 3) {
    // 23% tax for players
      let res: any = (amt * 23) / 100;
      return parseFloat(res);
    } else if (this.currentUser?.userDetails?.userType === 2 || this.currentUser.userType == 2) {
      // 15% tax for coaches
      let res: any = (amt * 15) / 100;
      return parseFloat(res);
    } else {
      // 0% tax for others
      return 0;
    }
  }

}
